module.exports = __webpack_public_path__ + "static/img/zkxx_banner.d1bf91d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zkxx_banner.png
// module id = /3MK
// module chunks = 52